import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SEARCH_POSTS_QUERY = gql`
  query searchPosts($search: String!, $language: String!, $searchOnlyByTitle: Boolean, $searchFields: [String]) {
    searchPosts(search: $search, language: $language, searchOnlyByTitle: $searchOnlyByTitle, searchFields: $searchFields) {
      slugName
      postCategory
      postDescription{
        title {
          en es ca pt
        }
        image{
          en
        }
      }
      active
    }
  }
`;

const getSearchPosts = async (search, language = 'en', searchOnlyByTitle = false, searchFields) => {
  try {
    const result = await client
      .query({
        query: SEARCH_POSTS_QUERY,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        variables: { search, language, searchOnlyByTitle, searchFields },
        fetchResults: true,
        pollInterva: 300000,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { searchPosts },
    } = result;

    if (searchPosts) {
      return searchPosts;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: searchPosts`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: searchPosts Error: ${error}`);
    return null;
  }
};

export default getSearchPosts;
